import { Outlet } from "react-router-dom";
import BottomBar from "@/components/bottom-bar";
import { useDesktopChrome } from "./responsive-routes";

export default function NavigationLayout() {
  const { hasSidebar } = useDesktopChrome();

  return (
    <>
      <Outlet />
      <div className={hasSidebar ? "lg:hidden" : undefined}>
        <BottomBar />
      </div>
    </>
  );
}
